module.exports = __webpack_public_path__ + "static/img/7.2a814747.jpg";